export default "__VITE_ASSET__DHUWHD$M__"